import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const UserService = {
  getAllClients: (params) =>
    axiosInstance.get(API_ENDPOINTS.USER.GET_ALL_CLIENTS, { params }),

  getAllCompanies: (params) =>
    axiosInstance.get(API_ENDPOINTS.USER.GET_ALL_COMPANIES, { params }),

  getDashboardSummary: ({ clientId, companyUserId, startDate, endDate }) =>
    axiosInstance.get(API_ENDPOINTS.USER.GET_DASHBOARD, {
      params: {
        clientId,
        companyUserId,
        startDate,
        endDate,
      },
    }),

  getAllEmployees: (params) =>
    axiosInstance.get(API_ENDPOINTS.USER.GET_ALL_EMPLOYEES, { params }),

  getDashboardBonus: () =>
    axiosInstance.get(API_ENDPOINTS.USER.GET_BONUS_INCENTIVE),

  getAllUsers: () => axiosInstance.get(API_ENDPOINTS.USER.GET_ALL),
  getUserById: (id) => axiosInstance.get(API_ENDPOINTS.USER.GET_BY_ID(id)),
  getCompanyById: (id) =>
    axiosInstance.get(API_ENDPOINTS.USER.GET_COMPANY_BY_ID(id)),
  getEmployeeById: (id) =>
    axiosInstance.get(API_ENDPOINTS.USER.GET_EMPLOYEE_BY_ID(id)),

  createClient: (data) =>
    axiosInstance.post(API_ENDPOINTS.USER.CREATE_CLIENT, data),
  createCompany: (data) =>
    axiosInstance.post(API_ENDPOINTS.USER.CREATE_COMPANY, data),
  createEmployee: (data) =>
    axiosInstance.post(API_ENDPOINTS.USER.CREATE_EMPLOYEE, data),

  updateUser: (id, data) =>
    axiosInstance.put(API_ENDPOINTS.USER.UPDATE(id), data),
  updateEmployee: (id, data) =>
    axiosInstance.put(API_ENDPOINTS.USER.UPDATE_EMPLOYEE(id), data),

  saveBank: (userId, data) =>
    axiosInstance.post(API_ENDPOINTS.USER.SAVE_BANK(userId), data),
  removeBank: (userId, paymentMethodId) =>
    axiosInstance.delete(
      API_ENDPOINTS.USER.REMOVE_BANK(userId, paymentMethodId),
    ),
  deleteUser: (id, roleName) =>
    axiosInstance.delete(API_ENDPOINTS.USER.DELETE(id, roleName)),
  deleteEmployee: (id) =>
    axiosInstance.delete(API_ENDPOINTS.USER.DELETE_EMPLOYEE(id)),
  updateCompany: (id, data) =>
    axiosInstance.put(API_ENDPOINTS.USER.UPDATE_COMPANY(id), data),
  deleteCompany: (id) =>
    axiosInstance.delete(API_ENDPOINTS.USER.DELETE_COMPANY(id)),
  updateCompanyStatus: (data) =>
    axiosInstance.put(API_ENDPOINTS.USER.UPDATE_COMPANY_STATUS, data),

  exportClientsCSV: (params) =>
    axiosInstance.get(API_ENDPOINTS.USER.EXPORT_CLIENTS_CSV, {
      params,
      responseType: "blob",
    }),
  exportCompaniesCSV: (params) =>
    axiosInstance.get(API_ENDPOINTS.USER.EXPORT_COMPANIES_CSV, {
      params,
      responseType: "blob",
    }),
  exportEmployeesCSV: (params) =>
    axiosInstance.get(API_ENDPOINTS.USER.EXPORT_EMPLOYEES_CSV, {
      params,
      responseType: "blob",
    }),

  getAllDepartments: (params) =>
    axiosInstance.get(API_ENDPOINTS.Department.GET_ALL_DEPARTMENTS, { params }),
  createDepartment: (data) =>
    axiosInstance.post(API_ENDPOINTS.Department.CREATE_DEPARTMENT, data),
  updateDepartment: (id, data) =>
    axiosInstance.put(API_ENDPOINTS.Department.UPDATE_DEPARTMENT(id), data),
  deleteDepartment: (id) =>
    axiosInstance.delete(API_ENDPOINTS.Department.DELETE_DEPARTMENT(id)),

  getAllDesignations: (params) =>
    axiosInstance.get(API_ENDPOINTS.Designation.GET_ALL_DESIGNATIONS, {
      params,
    }),
  createDesignation: (data) =>
    axiosInstance.post(API_ENDPOINTS.Designation.CREATE_DESIGNATIONS, data),
  updateDesignation: (id, data) =>
    axiosInstance.put(API_ENDPOINTS.Designation.UPDATE_DESIGNATIONS(id), data),
  deleteDesignation: (id) =>
    axiosInstance.delete(API_ENDPOINTS.Designation.DELETE_DESIGNATIONS(id)),
};

export default UserService;
